<script>
    import Button, { Label } from '@smui/button';
    import Checkbox from '@smui/checkbox';
    import Dialog, { Actions, Content, Title } from '@smui/dialog';
    import List, { Item, Meta } from '@smui/list';
    import { organizationStore } from "../organizations/organizations";
    import { currentUser } from "./users";

    let eventDialog;

    export function open() {
        eventDialog.setOpen(true);
    }

    export function close() {
        eventDialog.setOpen(false);
    }

</script>

<Dialog bind:this={eventDialog}>
    <Title id="title">Selecteer organisatie</Title>
    <Content id="content">
        <List>
            {#each $organizationStore as organization}
                <Item>
                    <Label>
                        {organization.name} #{organization.companyId}
                    </Label>
                    <Meta>
                        <Checkbox bind:group={$currentUser.organizations} value="{organization.companyId}"/>
                    </Meta>
                </Item>
            {/each}
        </List>
    </Content>
    <Actions>
        <Button  on:click={() => close()}>
            <Label>Close</Label>
        </Button>
    </Actions>
</Dialog>